import React from "react";
import { ItemUnderReviewModalPropsType } from "../../../constants/interface";
import bellIcon from "../../../assets/item-under-review-bell-frame.png";
import ActionButtons from "./ActionButtons";
import ModalBody from "./ModalBody";

const ItemUnderReviewModal: React.FC<ItemUnderReviewModalPropsType> = (
  props
) => {
  
  return (
    <div className="flex flex-col gap-3 bg-white p-5 pb-7 rounded-2xl max-w-[25rem]">
      <img src={bellIcon} alt="bell" className="w-full" />
      <ModalBody />
      <ActionButtons />
    </div>
  );
};

export default ItemUnderReviewModal;
